export default __webpack_public_path__ + "static/media/jkCement.3bd0002b.jpg";